(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        fetch(this.dataset.url)
          .then((res) => res.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const fresh = html.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) {
              this.innerHTML = fresh.innerHTML;
            }
          })
          .catch(() => {});
      }, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
